<template>
  <div class="main-body">
    <div class="header">NB报警器</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>
        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入Imei号" v-model="imei" clearable style="margin-right:10px;width:160px"></el-input>

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="imei" label="设备Imei号" width="150"></el-table-column>
        <el-table-column prop="placeName" label="位置" width="100"></el-table-column>
        <el-table-column label="设备类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType == 1">报警按钮</span>
            <span v-if="scope.row.deviceType == 2">人体红外探测器</span>
            <span v-if="scope.row.deviceType == 3">门磁探测器</span>
            <span v-if="scope.row.deviceType == 4">水浸探测器</span>
            <span v-if="scope.row.deviceType == 5">可燃气探测器</span>
            <span v-if="scope.row.deviceType == 6">一氧化碳探测器</span>
            <span v-if="scope.row.deviceType == 7">烟温探测器</span>

          </template>
        </el-table-column>
        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="getData(scope.$index, scope.row)" >数据</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"  v-on:getList="getList"></Add>
    <PushData ref="myPushData" v-show="pushDataShow" v-on:closePushData="closePushData"></PushData>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeGetElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import Add from "../Gov/Add"
import Elderly from "../Gov/Elderly";
import PushData from "../Comm/PushData";
import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Role",
  data() {
    return {

      showModalAdd:false,
      tableLoading:false,

      pushDataShow:false,
      showModalGetElderly:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',


    };
  },
  components: {Add,elSelectTree,Elderly,PushData},
  created() {
    this.getZone();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },


    getData(index,row){
      this.$refs.myPushData.init(row.userCode);
      this.pushDataShow =!this.pushDataShow;
    },
    closePushData(){
      this.pushDataShow =!this.pushDataShow;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWon/PageByGovCodeZoneCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          imei: this.imei,
          userCode:this.userCode,
          governmentCode:getGovernmentCode(),
          zoneCode:this.zoneCode,
          deviceType:-1,
        },
      }).then((response) => {
            _this.tableLoading=false
            if (response.data.error == 0) {
              this.tableData = response.data.data.list;
              this.totalItems = response.data.data.total;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message);
            }
          }).catch(function (error) {
            _this.tableLoading=false
            console.log(error);
          });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
            this.$axios({
              method: "post",
              url: this.$deviceUrl + "DeviceOWon/Delete",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                deviceOWonCode: row.deviceOWonCode,
              },
            }).then((response) => {
                  //console.log(response);
                  if (response.data.error == 0) {
                    this.$message({message: "解绑成功", type: "success",});
                    this.getList();
                  } else if (response.data.error == 1) {
                    this.$message.error(response.data.message);
                  }
                }).catch(function (error) {
                  console.log(error);
                });
          }).catch(() => {
            //this.$message({type: "info", message: "已取消解绑",});
          });
    },


    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },
    getZoneValue(val) {
      this.zoneCode = val
    },


  },
};
</script>

<style scoped>
</style>
